// extracted by mini-css-extract-plugin
export var container = "styles-module__container___w2amO";
export var cardColumn = "styles-module__cardColumn___uOMuG";
export var giftCard = "styles-module__giftCard___WNj5E";
export var header = "styles-module__header___LXfNh";
export var giftMessage = "styles-module__giftMessage___IbXnF";
export var metadata = "styles-module__metadata___mxCo4";
export var infoContainer = "styles-module__infoContainer___D_CoI";
export var value = "styles-module__value___u7JQk";
export var spacer = "styles-module__spacer___ZbXjb";
export var printStyles = "styles-module__printStyles___LLwl2";
export var metadataColumn = "styles-module__metadataColumn___rDJ2J";